<template>
    <div class="card-error">
        <div class="icon">
            <span>
                <em class="fa fa-exclamation-triangle icon"/>
            </span>
        </div>
        <div class="card-type">
            <span>Sua solicitação resultou em erro.</span>
            <p>Nossa equipe de suporte técnico recebeu um relatório deste erro.</p>
            <ul>
                <li>Se precisar de apoio, entre em contato com nosso departamento de suporte.</li>
                <li>suporte@appfacilita.com / Whatsapp : (11) 4949-5909</li>
                <li>De segunda a sexta das 08:30 às 18:30</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ui-views-iframe-errors'
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>


